const formatPrice = (num, showCurrency = true) => {
  return `${showCurrency ? window.Theme.currency: ''}${(parseInt(num) / 100).toLocaleString('en-EN', {
    minimumFractionDigits: 2
  })}`
}
let bundleCookie = 'bundleProudcts'+ window.bundleConfig.title;
let allBundleCookie = 'allBundleProudcts' + window.bundleConfig.title
var bundleProudcts = getBundleProducts() ;

if(!localStorage.getItem('pre-activity')){

}

async function _init(){
  await init()
  await renderBundleBox()
  // await stepUpdate()
}
$(document).ready(function(){
  stepUpdate()
})
async function showBundleBox(){
  $(document).find('.custom-bundle-box-content').addClass('active')
  $(document).find('.loading-overlay').hide()
}
_init()

// STEP UPDATE

async function stepUpdate () {
  let currentStep = localStorage.getItem('currentStep');
  let currentStepNumer = localStorage.getItem('currentStepNumer');
  let lastStep = localStorage.getItem('lastStep');
  let lastStepNumber = localStorage.getItem('lastStepNumer') || parseInt($('[last-step]').attr('data-step-number'));

  if(!currentStepNumer || lastStep == "undefined"){
    currentStepNumer = 1;
    localStorage.setItem('currentStepNumer', currentStepNumer)
  }
  if(!currentStep || currentStep == "undefined"){
    currentStep = $('.js-breadcrumb-item.active').attr('data-step-id')
    localStorage.setItem('currentStep', currentStep)
  }
  if(!lastStepNumber || lastStep == "undefined") {
    localStorage.setItem('lastStepNumber', $('[last-step]').attr('data-step-number'))
  }
  if(!lastStep || lastStep == "undefined" || lastStep != $('[last-step]').attr('data-step-id') ) {
    localStorage.setItem('lastStep', $('[last-step]').attr('data-step-id'))
  }
  if ($(`[data-step-id="${currentStep}"]`).length > 0){
    $('[data-step-id].active').removeClass('active')
    $(`[data-step-id="${currentStep}"]`).addClass('active')
  }

  $('.js-previous-step').show()

  if(parseInt(currentStepNumer) === 1){
    $('.js-previous-step').hide()
  }

  if (currentStep == lastStep ) {
    if (getBundleProducts().length > 0) {
      $('.js-next-step').html("checkout")
    } else {
      $('.js-next-step').hide()
    }
  } else {
    $('.js-next-step').show()
    $('.js-next-step').html("NEXT <span>STEP</span>")
  }
}

// Render Filter and Init Products
async function init () {

  if(!document.querySelector('#collection-handle-wrap')) return;
  let collectionInputs = document.querySelector('#collection-handle-wrap').querySelectorAll('input')
  if (collectionInputs) {
    for (let i = 0; i <  collectionInputs.length; i++) {
      let url = collectionInputs[i].dataset.url;
      let target_handle = collectionInputs[i].dataset.handle;
      const enableAddToBundleModal = collectionInputs[i].dataset.enableModal;
      let filter_url = url + "?view=bundle-filter";
      if( target_handle && url ) {
        if(enableAddToBundleModal == "true" ){
          url += "?view=bundle-with-modal"
        }
        else
          url += "?view=bundle";
        await renderProducts(url)
        await refreshProductCards()
        fetch(filter_url).then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          let filterWrap = document.querySelector(`.js-filter-wrap[data-handle="${target_handle}"]`)? document.querySelector(`.js-filter-wrap[data-handle="${target_handle}"]`) : null;
          if(filterWrap){
            let filter = responseHTML.querySelector('.filter-wrap')? responseHTML.querySelector('.filter-wrap'): null;
            filterWrap.innerHTML = filter.innerHTML
          }
        })
      }
    }
  }
}


$(document).on('click','.js-next-step',(e)=>{
  e.preventDefault();

  let lastStep = $('[last-step]').attr('data-step-id')
  let currentStpe = $('.js-breadcrumb-item.active').attr('data-step-id')
  let currentStepNumber = $('.js-breadcrumb-item.active').attr('data-step-number')
  const products = getBundleProducts()
  const hasCurrentStepItems = products.some(item => item.stepId === currentStpe)

  if (!hasCurrentStepItems && !!$('.js-breadcrumb-item.active').attr('required')) return;

  if (currentStpe != lastStep) {
    let stepNum = parseInt(currentStepNumber) + 1;
    let stepId = $(`.js-breadcrumb-item[data-step-number="${stepNum}"]`).attr('data-step-id')
    localStorage.setItem('currentStep',stepId)
    localStorage.setItem('currentStepNumer',stepNum)
    stepUpdate();

    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    addBundelToCart()
  }
})

// Add Bundle To Cart

function addBundelToCart () {

  let products = getBundleProducts().filter(product => product.bundleId === window.bundleConfig.id);

  if(products.length > 0)  {
    let items = []
    let bundleId =  Date.now()
    for (let i = 0; i < products.length; i++) {
      let item = {
        "id": products[i].variantId,
        "quantity": products[i].qty
      };

      if (products[i].properties) {
        item.properties = products[i].properties;
        item.properties.bundleId = bundleId;
        item.properties['_bundle_title'] = window.bundleConfig.title
        item.properties['_bundle_image'] = window.bundleConfig.image
      }

      items.push(item)
    }
    let data = {
      items
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      addBundleProducts(bundleId)
      localStorage.removeItem(bundleCookie)
      localStorage.removeItem('currentStep')
      localStorage.setItem('redirectUrl',location.href)
      location.href = '/cart'
    })
  }
}

$(document).on('click','.js-previous-step',(e)=>{
  e.preventDefault()
  let firstStep = $('[first-step]').attr('data-step-id')
  let currentStpe = $('.js-breadcrumb-item.active').attr('data-step-id')
  let currentStepNumber = $('.js-breadcrumb-item.active').attr('data-step-number')

  if(currentStpe != firstStep){
    let stepNum = parseInt(currentStepNumber) - 1;
    let stepId = $(`.js-breadcrumb-item[data-step-number="${stepNum}"]`).attr('data-step-id')
    localStorage.setItem('currentStep',stepId)
    localStorage.setItem('currentStepNumer',stepNum)
    stepUpdate();

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
})
$(document).on('click', '.js-breadcrumb-item', (e)=>{
  e.preventDefault();

  let currentStpe = $('.js-breadcrumb-item.active').attr('data-step-id')
  const products = getBundleProducts()
  const hasCurrentStepItems = products.some(item => item.stepId === currentStpe)

  if (!hasCurrentStepItems && !!$('.js-breadcrumb-item.active').attr('required')) return;

  localStorage.setItem('currentStep',e.target.dataset.stepId)
  localStorage.setItem('currentStepNumer',e.target.dataset.stepNumber)

  stepUpdate();
})



// BUNDLE TAB

$(document).on('click','.js-box-item',(e) => {
  e.preventDefault()
  if(!$(e.target).hasClass('active')){
    $('[data-target-box].active').removeClass('active');
    $(`[data-target-box="${e.target.dataset.targetBox}"]`).addClass('active')
  }else {
    $('[data-target-box].active').removeClass('active');
  }
})


//VARIANT SELECT

$(document).on('change','.option-value-input', (e)=>{
  const parent = e.target.closest('.product-form-grid');
  const card = e.target.closest('.bundle-product-card')
  const options = {}

  parent.querySelectorAll('[data-product-option]:checked').forEach(input => {
    options[input.dataset.productOption] = input.value
  })

  const selector = Object.keys(options).map(key => `[data-${key}="${options[key]}"]`).join('')
  const selectedOption = parent.querySelector('[name="id"]').querySelector(`option${selector}`);

  if (selectedOption.value) {
    parent.querySelector('[name="id"]').value  = selectedOption.value;
    card.querySelector('.price').innerHTML = decodeURIComponent(selectedOption.dataset.price).replace(/\+/g, ' ');

    if (!!selectedOption.dataset.variantImg) {
      $(card).find('.product-card-figure').html(decodeURIComponent(selectedOption.dataset.variantImg).replace(/\+/g, ' '))
    }

    if (!!card.dataset.freeProductId) {
      const replaceCard = document.querySelector(`.bundle-product-card[data-product-id="${card.dataset.freeProductId}"]`)
      const replaceOption = replaceCard.querySelector('[name="id"]').querySelector(`option${selector}`);
      replaceCard.querySelector('[name="id"]').value = replaceOption.value
    }

    const bundleProducts = getBundleProducts()
    if (selectedOption.hasAttribute('disabled')) {
      card.querySelectorAll('.product-submit').forEach(button => {
        button.setAttribute('disabled', 'disabled')
        button.querySelector('.btn-label:not(.added)').innerHTML = 'Sold Out'
      })
    } else {
      card.querySelectorAll('.product-submit').forEach(button => {
        button.removeAttribute('disabled')
        button.querySelector('.btn-label:not(.added)').innerHTML = 'Add'
      })
    }

    const giftTotal = bundleProducts.filter(item => item.stepId === 'gifts').map(item => item.variant.price)
        .reduce((a, b) => a + b, 0);

    if (giftTotal >= 5000) {
      document.querySelectorAll('.bundle-product-card[data-free-product-id]').forEach(item => {
        item.querySelector('.price-regular').classList.add('strike')
        item.querySelector('.price-compare').classList.remove('hidden')
      })
    } else {
      document.querySelectorAll('.bundle-product-card[data-free-product-id]').forEach(item => {
        item.querySelector('.price-regular').classList.remove('strike')
        item.querySelector('.price-compare').classList.add('hidden')
      })
    }
  }
})


// Filter

$(document).on('click','.js-filter-close',(e)=>{
  e.preventDefault()
  $(e.target).closest('.js-filter-wrap').removeClass('open')
  $('html').removeClass('scroll-locked')
})

$(document).on('click','.js-bundle-filter', (e)=> {
  e.target.closest('.js-bundle-tab').querySelector('.js-filter-wrap').classList.add('open')

  $('html').addClass('scroll-locked')
})


$(document).on('change','.filter-group-metafield-occasions',(e)=> {
  if (e.target.closest('.js-bundle-tab')) {
    search(e.target.closest('.js-bundle-tab').dataset.handle)
  }
})

$(document).on('change','.filter-group-metafield-type',(e)=> {
  if(e.target.closest('.js-bundle-tab')){
    search(e.target.closest('.js-bundle-tab').dataset.handle)
  }
})

$(document).on('input','.js-bundle-search',(e)=> {
  if(e.target.closest('.js-bundle-tab')){
    search(e.target.closest('.js-bundle-tab').dataset.handle)
  }
})

function closeSort (){
  $(document).find('.bundle-sort-by').hide()
  $(document).find('.page-overlay').removeClass('active')
}
$(document).on('click','.page-overlay',(e)=>{
  closeSort()
})
$(document).on('click','.js-btn-sort-by',(e)=> {
  $(e.target).parent('.collection-sorter').find('.bundle-sort-by').show()
  $(document).find('.page-overlay').addClass('active')
})

$(document).on('change','.bundle-sort-by input',(e)=>{
  ajaxFilter(e)
  closeSort()
})
$(document).on('change','.filter-group-color',(e)=>{
  ajaxFilter(e)
})
$(document).on('change','.filter-group-size',(e)=>{
  ajaxFilter(e)
})
$(document).on('change','.filter-group-price-range',(e)=>{
  ajaxFilter(e)
})


$(document).on('input','[data-id="rangeMax"]',(e)=>{
  const currentTab = e.target.closest('.js-bundle-tab');
    let priceMax = parseFloat(e.target.value);
    if(currentTab.querySelector('[data-id="rangeMin"]').value >= priceMax) {
      e.target.disabled = true
      e.target.value = currentTab.querySelector('[data-id="rangeMin"]').value
      setTimeout(() => {
        e.target.disabled = false
      }, 300);
    }
    currentTab.querySelector('.js-max-price').textContent = formatPrice(priceMax, false)
})
$(document).on('input','[data-id="rangeMin"]',(e)=>{
  const currentTab = e.target.closest('.js-bundle-tab');
    let priceMin = parseFloat(e.target.value);
    if(currentTab.querySelector('[data-id="rangeMax"]').value <= priceMin) {
      e.target.disabled = true
      e.target.value = currentTab.querySelector('[data-id="rangeMax"]').value
      setTimeout(() => {
        e.target.disabled = false
      }, 300);
    }
    currentTab.querySelector('.js-min-price').textContent = formatPrice(priceMin, false)
})

function ajaxFilter (event) {
  if(event.target.closest('.js-bundle-tab')){
    const currentTab    = event.target.closest('.js-bundle-tab');
    const enableAddToBundleModal = currentTab.dataset.enableModal;
    const currentUrl    = currentTab.dataset.url;
    let filteredUrl = currentUrl;

    if(enableAddToBundleModal.indexOf('true') != -1)
      filteredUrl += "?view=bundle-with-modal"
    else
      filteredUrl += "?view=bundle";
    let pageNum = 1;
    if(currentTab.querySelector('[data-id="rangeMin"]')){
      let priceMin = parseFloat(currentTab.querySelector('[data-id="rangeMin"]').value) / 100;
      let priceMinParam = currentTab.querySelector('[data-id="rangeMin"]').dataset.priceMin;
      filteredUrl += "&" + priceMinParam + "=" + priceMin;
    }
    if(currentTab.querySelector('[data-id="rangeMax"]')){
      let priceMax = parseFloat(currentTab.querySelector('[data-id="rangeMax"]').value) / 100;
      let priceMaxParam = currentTab.querySelector('[data-id="rangeMax"]').dataset.priceMax;
      filteredUrl += "&" + priceMaxParam + "=" + priceMax;
    }

    if(currentTab.querySelector('.filter-group-size')){
      let sizeWrap = currentTab.querySelector('.filter-group-size');
      if(sizeWrap.querySelectorAll('input:checked')){
        let sizeFilterArr = sizeWrap.querySelectorAll('input:checked');
        if(sizeFilterArr.length > 0) {
          for (let i = 0; i < sizeFilterArr.length; i++) {
            const element = sizeFilterArr[i];
            let filterValue = element.value;
            let filterParam = element.getAttribute('name');
            filteredUrl += "&" + filterParam + "=" + filterValue;
          }
        }
      }
    }
    if(currentTab.querySelector('.filter-group-color')){
      let colorWrap = currentTab.querySelector('.filter-group-color');
      if(colorWrap.querySelectorAll('input:checked')){
        let colorFilterArr = colorWrap.querySelectorAll('input:checked');
        if(colorFilterArr.length > 0) {
          for (let i = 0; i < colorFilterArr.length; i++) {
            const element = colorFilterArr[i];
            let filterValue = element.value;
            let filterParam = element.getAttribute('name');
            filteredUrl += "&" + filterParam + "=" + filterValue;
          }
        }
      }
    }
    if(event.target.closest('.js-bundle-tab').querySelector('.bundle-sort-by')){
      filteredUrl += "&sort_by="+ document.querySelector('.bundle-sort-by input:checked').value;
    }
    renderProducts(filteredUrl)
  }
}

async function _renderProducts(handle,filterQuery){
  await fetch(filterQuery).then((response) => response.text())
  .then((responseText) => {
    const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
    let products = responseHTML.querySelectorAll('.bundle-product-card');

    for (let i = 0; i < products.length; i++) {
      const element = products[i];
      document.querySelector(`.bundle-products[data-handle="${handle}"]`).appendChild(element)
    }
  })
}

async function renderProducts( filteredUrl = ''){
  fetch(filteredUrl).then((response) => response.text())
  .then(async (responseText) => {
    const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
    let collectinData = JSON.parse(responseHTML.querySelector('.collection-data').textContent)
    const handle = collectinData.handle;
    const pageSize = collectinData.page_size;
    document.querySelector(`.bundle-products[data-handle="${handle}"]`).replaceChildren();
    for (let i = 1; i <= pageSize; i++) {
      let filterQuery = filteredUrl + "&page=" + i;
      await _renderProducts(handle,filterQuery);
    }
    await search(handle)
    await refreshProductCards()
  })
}
// Search

async function search(handle){
  let parent = $(`.js-bundle-tab[data-handle="${handle}"]`)
  let products = parent.find('.bundle-product-card')
  let filterOccasions = parent.find('.filter-group-metafield-occasions input:checked');
  let filterTypes = parent.find('.filter-group-metafield-type input:checked');
  let title = ""
  parent.removeClass('filtered')
  parent.removeClass('searched')
  if (parent.find('.js-bundle-search').length > 0 ) {

    title = (parent.find('.js-bundle-search').val() || '').toLowerCase()

    if (title != "") {
      $(`.js-bundle-tab[data-handle="${handle}"]`).addClass('searched')
    }
  }
  if(filterOccasions.length != 0 || filterTypes.length != 0){
    parent.addClass('filtered')
  }

  if (products.length > 0 ) {
    for (let i = 0; i < products.length; i++) {
      const element = products[i];
      $(element).removeClass('active-searched')
      $(element).removeClass('active-filtered')
      if($(element).attr('data-search-title').indexOf(title) != -1){
        $(element).addClass('active-searched')
      }
      for (let j = 0; j < filterOccasions.length; j++) {
        if($(element).attr('data-search-occasions').indexOf(filterOccasions.eq(j).val()) != -1){
          $(element).addClass('active-filtered')
        }
      }
      for (let k = 0; k < filterTypes.length; k++) {
        if($(element).attr('data-search-type').indexOf(filterTypes.eq(k).val()) != -1){
          $(element).addClass('active-filtered')
        }
      }
    }
  }
  // if(parent.hasClass('filtered') && parent.hasClass('searched')) {
  //   if(parent.find('.active-filtered.active-searched').length == 0 ){
  //     $(parent).find('.no-search-result').hide()
  //   }else{
  //     $(parent).find('.no-search-result').show()
  //   }
  // } else if (parent.hasClass('filtered') ){
  //   if(parent.find('.active-filtered').length == 0 ){
  //     $(parent).find('.no-search-result').hide()
  //   }else{
  //     $(parent).find('.no-search-result').show()
  //   }
  // } else if (parent.hasClass('searched') ){
  //   if(parent.find('.active-searched').length == 0 ){
  //     $(parent).find('.no-search-result').hide()
  //   }else{
  //     $(parent).find('.no-search-result').show()
  //   }
  // }
}

function getVaraint(variantId = null){
  if(document.querySelector(`#variant-data-${variantId}`)){
    return JSON.parse(document.querySelector(`#variant-data-${variantId}`).textContent)
  }
  return null;
}

// Add to bundle
async function addToBundle(productCard = null, properties = {}){
  let bundleProudcts = getBundleProducts()
  const stepId = productCard.closest('.js-bundle-tab').dataset.stepId;
  const stepType = productCard.closest('.js-bundle-tab').dataset.stepType;
  const productId = productCard.dataset.productId;
  const variantId = productCard.querySelector('[name="id"]').value;
  const variant = getVaraint(variantId);
  const imageUrl = productCard.querySelector('.product-card-figure img').getAttribute('src')
  const productTitle = productCard.dataset.searchTitle;
  let qty = productCard.querySelector('.product-quantity-input').value;
  let bundleProduct = {
    stepId,
    stepType,
    productId,
    variantId,
    variant: {
      id: variant.id,
      price: variant.price,
      title: variant.title
    },
    imageUrl,
    productTitle,
    qty,
    bundleId: window.bundleConfig.id,
    properties
  }
  const item = bundleProudcts.find(item => item.variantId === bundleProduct.variantId)
  if(item){
    console.log(item)
    item.qty = parseInt(item.qty) + parseInt(bundleProduct.qty)
    productCard.querySelector('.product-quantity-input').value = 1
  } else{
    bundleProudcts.push(bundleProduct)
    productCard.querySelector('.product-quantity-input').value = 1;
  }
  setBundleProducts(bundleProudcts)
  renderBundleBox()
  stepUpdate()
}



function getBundleProducts(){

  if(localStorage.getItem(bundleCookie)){
    return JSON.parse(localStorage.getItem(bundleCookie))
  }else{
    return [];
  }
}

function setBundleProducts(bundleProudcts = null){
  if(!bundleProudcts) return;
  const producstStringData = JSON.stringify(bundleProudcts)
  localStorage.setItem(bundleCookie,producstStringData)
}


function getAllBundleProducts(){
  if(localStorage.getItem(allBundleCookie)){
    return JSON.parse(localStorage.getItem(allBundleCookie))
  }else{
    return [];
  }
}

function setAllBundleProducts(allBundleProudcts = null){
  if(!allBundleProudcts) return;
  const producstStringData = JSON.stringify(allBundleProudcts)
  localStorage.setItem(allBundleCookie,producstStringData)
}
function addBundleProducts(bundleId){
  let allProducstStringData = getAllBundleProducts()
  let bundleProducts = getBundleProducts()

  bundleProducts.map((product) => {
    product.bundleId = bundleId;
    allProducstStringData.push(product)
  })
  setAllBundleProducts(allProducstStringData)
}


async function renderBundleBox(){
  let totalBundlePrice = 0;
  if(getBundleProducts().length > 0){
    let bundleProducts = getBundleProducts()
    $(`.box-products`).html('')
    for(let i = 0; i < bundleProducts.length; i ++) {
      const bundleProdctData = bundleProducts[i];
      let options = '';
      if(bundleProdctData.variant.option1 && bundleProdctData.variant.option1.indexOf('Default Title') != 0){
        options += bundleProdctData.variant.option1;
      }
      if(bundleProdctData.variant.option2 && bundleProdctData.variant.option1.indexOf('Default Title') != 0){
        options += "/" + bundleProdctData.variant.option2;
      }
      totalBundlePrice += bundleProdctData.variant.price * bundleProdctData.qty;
      let price = 'Free';

      if(bundleProdctData.variant.price > 0) {
        price = formatPrice(bundleProdctData.variant.price);
      }

      let bundleProductHtml = `
          <div class="bundle-product" data-variant-id="${bundleProdctData.variantId}" data-product-id="${bundleProdctData.productId}">
            <button class="remove-bunndle-product">&times;</button>
            <div class="bundle-product-image-wrap">
              <img src="${bundleProdctData.imageUrl}" alt="">
            </div>
            <h2 class="bundle-product-title">${bundleProdctData.productTitle}</h2>
            <div class="bundle-product-options-label">${(bundleProdctData.variant.title =='Default Title') ? '' : bundleProdctData.variant.title}</div>
            <div class="bundle-product-footer">
              <span class="bundle-product-price">${price}</span>
              <span class="bundle-product-qty">${bundleProdctData.qty}</span>
            </div>
          </div>`;
        $(`.js-box-tab-item[data-target-box=${bundleProdctData.stepId}]`).find('.box-products').append(bundleProductHtml)

    }
  }else {
    $(`.box-products`).html('')
  }
  $('.js-bundle-total-price').text(formatPrice(totalBundlePrice))
  await refreshProductCards()
  await showBundleBox()
}
async function refreshProductCards(){
  let bundleProducts = getBundleProducts()
  $('.bundle-product-card.added').removeClass('added')

  if(bundleProducts.length > 0){
    for (let i = 0; i < bundleProducts.length; i++) {
      const bundleProduct = bundleProducts[i];
      const productId = bundleProduct.productId;
      $(`.bundle-product-card[data-product-id="${productId}"`).addClass('added')
     // $(`.bundle-product-card[data-product-id="${productId}"`).find('.product-quantity-input').val(bundleProduct.qty)
    }
  }

  const giftTotal = bundleProducts.filter(item => item.stepId === 'gifts').map(item => item.variant.price)
      .reduce((a, b) => a + b, 0);

  if (giftTotal >= 5000) {
    document.querySelectorAll('.bundle-product-card[data-free-product-id]').forEach(item => {
      item.querySelector('.price-regular').classList.add('strike')
      item.querySelector('.price-compare').classList.remove('hidden')
    })
  } else {
    document.querySelectorAll('.bundle-product-card[data-free-product-id]').forEach(item => {
      item.querySelector('.price-regular').classList.remove('strike')
      item.querySelector('.price-compare').classList.add('hidden')
    })
  }
}
$(document).on('click','.remove-bunndle-product',(e)=>{
  if(e.target.closest('.bundle-product')){
    removeBundleProduct(e.target.closest('.bundle-product'))
  }
})
// Change QTY


// Bundle Products
function removeBundleProduct(bundleProduct = null) {
  if(bundleProduct){

    let bundleProudcts = getBundleProducts()

    let deleteVariantId = bundleProduct.dataset.variantId;
    let products = bundleProudcts.filter((product)=>{
      console.log(product.variantId)
      console.log(deleteVariantId)
      //if(product.productId != deleteProductId )
        if(product.variantId != deleteVariantId)
          return product
    })
    setBundleProducts(products)
    renderBundleBox()
    stepUpdate()
  }
}

$(document).on('click', '.btn-add-to-bundle', async (e)=>{
  const tab = e.target.closest('.js-bundle-tab')
  const card = e.target.closest('.bundle-product-card')
  const bundleProudcts = getBundleProducts()
  const giftTotal = bundleProudcts.filter(item => item.stepId === 'gifts').map(item => item.variant.price)
      .reduce((a, b) => a + b, 0);

  if (giftTotal >= 5000) {
    document.querySelectorAll('.bundle-product-card[data-free-product-id]').forEach(item => {
      item.querySelector('.price-regular').classList.add('strike')
      item.querySelector('.price-compare').classList.remove('hidden')
    })
  } else {
    document.querySelectorAll('.bundle-product-card[data-free-product-id]').forEach(item => {
      item.querySelector('.price-regular').classList.remove('strike')
      item.querySelector('.price-compare').classList.add('hidden')
    })
  }

  if (!card) return;
  //if (card.classList.contains('added')) return;

  if (tab.dataset.stepId === 'cards') {
    !!card.querySelector('.properties-popup') && card.querySelector('.properties-popup').classList.add('active');
  } else {

    if (card.dataset.freeProductId && giftTotal >= 5000) {
      const cardReplace = document.querySelector(`.bundle-product-card[data-product-id="${card.dataset.freeProductId}"]`)
      addToBundle(cardReplace)
    } else {
      addToBundle(card)
    }
  }
})

$(document).on('submit', '.js-bundle-properties-form', function (e) {
  e.preventDefault();
  const properties = {}
  const formData = $(this).serializeArray();
  const card = e.target.closest('.bundle-product-card')

  formData.forEach((property) => {
    properties[property.name] = property.value
  })

  addToBundle(card, properties)

  card.querySelector('.properties-popup').classList.remove('active');
})

$(document).on('click','.js-add-to-bundle-popup',async (e)=>{

    // if(e.target.closest('.bundle-product-card').dataset.personalize != 'true'){
      await addToBundle(e.target.closest('.product-card-popup'))
      e.target.closest('.popup ').classList.remove('active')
    // }
    // else {
    //   localStorage.setItem('redirectUrl',location.href)
    //   location.href = e.target.closest('.bundle-product-card').dataset.url + "?view=bundle"
    // }

})

$(document).on('click','.js-add-to-bundle-popup',async (e)=>{
  const btn = e.target.closest('.js-add-to-bundle-popup');

  if ( btn.classList.contains('product-customize')) {
    localStorage.setItem('redirectUrl',location.href)
    location.href = e.target.closest('.bundle-product-card').dataset.url + "?view=bundle"
  }
})

$(document).on('click', '.redirect-personalize-pdp', (e)=>{

    localStorage.setItem('redirectUrl',location.href)
    location.href = e.target.closest('.bundle-product-card').dataset.url + "?view=bundle"

})


$(document).on('click','.show-bundle-modal',(e)=>{
  e.preventDefault()
  if(e.target.closest('.bundle-product-card')){

      $('.add-to-bundle-modal.active').removeClass('active')
      $(e.target).closest('.bundle-product-card').find('.add-to-bundle-modal').addClass('active')

  }
})

$(document).on('click','.overlay',(e)=>{
  $(e.target).parent('.popup').removeClass('active')
})


// Detail Popup

$(document).on('click','.js-btn-show-detal-popup',(e)=>{
  e.preventDefault()
  if(e.target.closest('.bundle-product-card')){
    $('.detail-popup.active').removeClass('active')
    $(e.target).closest('.bundle-product-card').find('.detail-popup').addClass('active')
  }
})
$(document).on('click','.js-close-popup',(e)=>{
  e.preventDefault()
  if(e.target.closest('.popup')){
    $(e.target).closest('.popup').removeClass('active')
  }
})


// Qty update
$(document).on('click','.qty-btn',(e)=>{
  let qty = parseInt($(e.target.closest('.bundle-product-card')).find('.product-quantity-input').val())

  if($(e.target).hasClass('plus')){
    qty ++;
    $(e.target.closest('.bundle-product-card')).find('.product-quantity-input').val(qty)
  }
  if($(e.target).hasClass('minus')){
    if(qty > 1){
      qty --;
      $(e.target.closest('.bundle-product-card')).find('.product-quantity-input').val(qty)
    }
  }

})


// BoxSlider

$('.box-overlay').on('mousedown', e => start(e));
$('.box-overlay').on('touchstart', e => start(e));

$('.box-overlay').on('mousemove',e => move(e));
$('.box-overlay').on('touchmove',e => move(e));

$('.box-overlay').on('mouseleave',e => end(e));
$('.box-overlay').on('mouseup',e => end(e));
$('.box-overlay').on('touchend',e => end(e));

let startX = 0;
let endX = 0;
let draged = false;
function start(event){
  startX = event.offsetX;
  draged = true;
}
function move(event){
  if(draged){
    endX = event.offsetX;
    let movedPx =  endX - startX;
    let currentX = document.querySelector('.boxs-wrap-scroll').scrollLeft;
    let len = currentX - movedPx;
    document.querySelector('.boxs-wrap-scroll').scrollLeft = len
  }else{
    return
  }
}
function end(event){
  draged = false;
}




